import ErrorOutlineOutlined from '@mui/icons-material/ErrorOutlineOutlined';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Box, Button, Typography } from '@mui/material';
import { styles } from './styles';

interface ErrorStateProps {
  onRetry?: () => void;
  title?: string;
}

export const ErrorState = ({ onRetry }: ErrorStateProps) => {
  return (
    <Box sx={styles.errorStateContainer}>
      <ErrorOutlineOutlined sx={styles.errorStateIcon} />

      <Typography variant="caption" sx={styles.errorStateText}>
        Error loading download history
      </Typography>

      {onRetry && (
        <Button
          variant="text"
          color="secondary"
          startIcon={<RefreshIcon />}
          onClick={onRetry}
          size="small"
          sx={styles.errorStateButton}
        >
          Try Again
        </Button>
      )}
    </Box>
  );
};
